// // src/lib/firebase.js
// import { initializeApp } from "firebase/app";
// // import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
// import { getMessaging, getToken, onMessage as fbOnMessage, isSupported } from "firebase/messaging";
// const firebaseConfig = {
//   apiKey: "AIzaSyArTSOTCH3_zbJ-f-W6kKInojxl03gBpBU",
//   authDomain: "sgc-notification.firebaseapp.com",
//   // databaseURL: "https://notification-a721e.firebaseio.com",
//   projectId: "sgc-notification",
//   storageBucket: "sgc-notification.firebasestorage.app",
//   messagingSenderId: "968474600540",
//   appId: "1:968474600540:web:091e9e55055e436033b299"
// };

// // Initialize Firebase
// const firebaseApp = initializeApp(firebaseConfig);

// // Initialize messaging variable
// let messaging = null;
// let messagingInitialized = false;

// // Function to initialize messaging safely
// const initializeMessaging = async () => {
//   if (messagingInitialized) {
//     return messaging;
//   }

//   // Only run in browser environment
//   if (typeof window === "undefined") {
//     console.warn("Firebase messaging can only be initialized in browser environment");
//     return null;
//   }

//   // Check if service worker is supported
//   if (!("serviceWorker" in navigator)) {
//     console.warn("Service Worker not supported in this browser");
//     return null;
//   }

//   try {
//     // Check if messaging is supported
//     const supported = await isSupported();
//     if (supported) {
//       messaging = getMessaging(firebaseApp);
//       messagingInitialized = true;
//       console.log("Firebase messaging initialized successfully");
//     } else {
//       console.warn("Firebase messaging not supported in this browser");
//     }
//   } catch (error) {
//     console.warn("Error initializing Firebase messaging:", error);
//     messaging = null;
//   }

//   return messaging;
// };

// // Safe wrapper for getToken
// const safeGetToken = async (vapidKey) => {
//   try {
//     const messagingInstance = await getMessagingInstance();
//     if (!messagingInstance) {
//       throw new Error("Messaging not initialized");
//     }
//     return await getToken(messagingInstance, { vapidKey });
//   } catch (error) {
//     console.error("Error getting FCM token:", error);
//     return null;
//   }
// };


// // Function to get messaging instance
// const getMessagingInstance = async () => {
//   if (!messaging && !messagingInitialized) {
//     await initializeMessaging();
//   }
//   return messaging;
// };

// // Check if messaging is supported (wrapper)
// const checkMessagingSupport = async () => {
//   try {
//     if (typeof window === "undefined") return false;
//     return await isSupported();
//   } catch (error) {
//     console.warn("Error checking messaging support:", error);
//     return false;
//   }
// };

// const onMessageListener = async (callback) => {
//   const messagingInstance = await getMessagingInstance();
//   if (!messagingInstance) {
//     console.warn("Messaging not initialized");
//     return () => {};
//   }
//   return fbOnMessage(messagingInstance, callback);
// };

// export { 
//   messaging, 
//   getMessagingInstance,
//   initializeMessaging,
//   safeGetToken as getToken, 
//   onMessageListener, 
//   checkMessagingSupport as isSupported,
//   getMessaging
// };






import { initializeApp } from "firebase/app";
import { getMessaging, getToken as fbGetToken, onMessage as fbOnMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
 apiKey: "AIzaSyBbNHV0wPTrnTT1ibMSHH3h2qBd8XDxJsU",
  authDomain: "notification-a721e.firebaseapp.com",
  databaseURL: "https://notification-a721e.firebaseio.com",
  projectId: "notification-a721e",
  storageBucket: "notification-a721e.firebasestorage.app",
  messagingSenderId: "488367706561",
  appId: "1:488367706561:web:69c02e5711ef2a67e35f40"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize messaging
let messagingInstance = null;
let messagingInitialized = false;

const initializeMessaging = async () => {
  if (messagingInitialized) return messagingInstance;

  const supported = await isSupported();
  if (!supported) {
    console.warn("Firebase messaging not supported in this browser");
    return null;
  }

  messagingInstance = getMessaging(firebaseApp);
  messagingInitialized = true;
  return messagingInstance;
};

// ✅ Safe getToken with explicit service worker (Edge fix)
const safeGetToken = async (vapidKey) => {
  try {
    const messaging = await initializeMessaging();
    if (!messaging) throw new Error("Messaging not initialized");

    // Register service worker explicitly
    const swReg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    return await fbGetToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swReg   // 🔑 Fix for Edge
    });
  } catch (error) {
    console.error("Error getting FCM token:", error);
    return null;
  }
};

const onMessageListener = async (callback) => {
  const messaging = await initializeMessaging();
  if (!messaging) return () => {};
  return fbOnMessage(messaging, callback);
};

export {
  initializeMessaging,
  safeGetToken as getToken,
  onMessageListener,
  isSupported
};